// 性能优化脚本
(function() {
  'use strict';

  // 图片懒加载优化
  function initLazyLoading() {
    if ('IntersectionObserver' in window) {
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            if (img.dataset.src) {
              img.src = img.dataset.src;
              img.classList.remove('lazy');
              observer.unobserve(img);
            }
          }
        });
      });

      document.querySelectorAll('img[data-src]').forEach(img => {
        imageObserver.observe(img);
      });
    }
  }

  // 预加载关键资源
  function preloadCriticalResources() {
    const criticalResources = [
      { href: '{{ "theme.js" | asset_url }}', as: 'script' },
      { href: '{{ "vendor.min.js" | asset_url }}', as: 'script' },
      { href: '{{ "theme.css" | asset_url }}', as: 'style' }
    ];

    // 优先预加载关键CSS以改善FCP
    criticalResources.forEach(resource => {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = resource.as;
      link.href = resource.href;
      if (resource.as === 'style') {
        link.onload = function() { this.onload=null;this.rel='stylesheet' };
        link.rel = 'stylesheet';
      }
      document.head.appendChild(link);
    });

    // 预加载关键图片改善LCP
    const heroImage = document.querySelector('.hero img, .banner img, .featured-image img');
    if (heroImage && heroImage.src) {
      const imageLink = document.createElement('link');
      imageLink.rel = 'preload';
      imageLink.as = 'image';
      imageLink.href = heroImage.src;
      imageLink.fetchpriority = 'high';
      document.head.insertBefore(imageLink, document.head.firstChild);
    }
  }

  // 优化字体加载
  function optimizeFontLoading() {
    if ('fonts' in document) {
      document.fonts.ready.then(() => {
        document.documentElement.classList.add('fonts-loaded');
      });
    }
  }

  // 减少重排重绘
  function optimizeLayout() {
    let ticking = false;
    
    function updateLayout() {
      // 批量更新 DOM
      requestAnimationFrame(() => {
        // 执行布局相关操作
        if (window.theme && window.theme.calc100vh) {
          window.theme.calc100vh();
        }
        ticking = false;
      });
    }

    function requestTick() {
      if (!ticking) {
        requestAnimationFrame(updateLayout);
        ticking = true;
      }
    }

    window.addEventListener('resize', requestTick);
    window.addEventListener('orientationchange', requestTick);
  }

  // 延迟非关键脚本
  function deferNonCriticalScripts() {
    const scripts = document.querySelectorAll('script[data-defer]');
    scripts.forEach(script => {
      script.defer = true;
    });
  }

  // 优化图片加载
  function optimizeImageLoading() {
    // 识别首屏关键图片（LCP候选元素）
    const criticalImages = document.querySelectorAll('.hero img, .banner img, .featured-product img, .above-fold img');
    const foldImages = [];
    
    // 检测首屏图片
    criticalImages.forEach(img => {
      const rect = img.getBoundingClientRect();
      if (rect.top < window.innerHeight) {
        foldImages.push(img);
      }
    });

    // 为所有图片添加 loading="lazy" 属性
    const images = document.querySelectorAll('img:not([loading])');
    images.forEach(img => {
      if (foldImages.includes(img)) {
        // 首屏关键图片立即加载
        img.loading = 'eager';
        img.decoding = 'sync';
        img.fetchpriority = 'high';
      } else {
        img.loading = 'lazy';
        img.decoding = 'async';
      }
    });

    // 移动端特定优化
    if (window.innerWidth <= 768) {
      // 移动端LCP图片优化
      const lcpImage = document.querySelector('.hero img, .banner img');
      if (lcpImage) {
        lcpImage.loading = 'eager';
        lcpImage.decoding = 'sync';
        lcpImage.fetchpriority = 'high';
        
        // 确保移动端使用合适尺寸
        if (lcpImage.srcset) {
          const mobileSrcset = lcpImage.srcset.replace(/(\d+)w/g, (match, width) => {
            const newWidth = Math.min(parseInt(width), Math.min(window.innerWidth * 2, 800));
            return newWidth + 'w';
          });
          lcpImage.srcset = mobileSrcset;
        }
      }

      // 其他移动端图片优化
      const otherImages = document.querySelectorAll('img:not(.hero img):not(.banner img)');
      otherImages.forEach(img => {
        if (img.srcset) {
          const newSrcset = img.srcset.replace(/(\d+)w/g, (match, width) => {
            const newWidth = Math.min(parseInt(width), 600);
            return newWidth + 'w';
          });
          img.srcset = newSrcset;
        }
      });
    }
  }

  // 预加载下一页资源
  function preloadNextPage() {
    const links = document.querySelectorAll('a[href*="/products/"], a[href*="/collections/"]');
    const preloadedUrls = new Set();

    links.forEach(link => {
      const href = link.href;
      if (!preloadedUrls.has(href)) {
        preloadedUrls.add(href);
        
        // 预加载链接页面
        const prefetchLink = document.createElement('link');
        prefetchLink.rel = 'prefetch';
        prefetchLink.href = href;
        document.head.appendChild(prefetchLink);
      }
    });
  }

  // 移动端触摸优化
  function optimizeTouchInteractions() {
    if (window.innerWidth <= 768) {
      // 优化触摸事件
      const touchElements = document.querySelectorAll('button, a, .clickable');
      touchElements.forEach(element => {
        element.style.touchAction = 'manipulation';
        element.style.webkitTapHighlightColor = 'transparent';
      });

      // 防止双击缩放
      let lastTouchEnd = 0;
      document.addEventListener('touchend', function(event) {
        const now = (new Date()).getTime();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      }, false);
    }
  }

  // 移动端视口优化
  function optimizeViewport() {
    if (window.innerWidth <= 768) {
      // 设置移动端视口
      const viewport = document.querySelector('meta[name="viewport"]');
      if (viewport) {
        viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
      }

      // 优化移动端滚动
      document.body.style.webkitOverflowScrolling = 'touch';
      document.body.style.overflowScrolling = 'touch';
    }
  }

  // 关键CSS内联优化（改善FCP）
  function inlineCriticalCSS() {
    // 检查是否已有内联关键CSS
    if (!document.querySelector('style[data-critical]')) {
      const criticalCSS = `
        /* 关键渲染路径CSS - 移动端优先 */
        body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; }
        .hero, .banner, .featured-product { position: relative; }
        img[loading="eager"] { display: block; max-width: 100%; height: auto; }
        .above-fold { min-height: 50vh; }
        
        @media (max-width: 768px) {
          .hero img, .banner img { 
            width: 100%; 
            height: auto; 
            object-fit: cover; 
          }
        }
      `;
      
      const style = document.createElement('style');
      style.setAttribute('data-critical', 'true');
      style.textContent = criticalCSS;
      document.head.insertBefore(style, document.head.firstChild);
    }
  }

  // DNS预解析优化（改善TTFB）
  function preconnectDomains() {
    const domains = [
      'https://cdn.shopifycdn.com',
      'https://fonts.googleapis.com',
      'https://fonts.gstatic.com',
      'https://www.google-analytics.com',
      'https://www.googletagmanager.com'
    ];

    domains.forEach(domain => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = domain;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    });
  }

  // 减少第三方脚本阻塞
  function optimizeThirdPartyScripts() {
    // 延迟加载非关键第三方脚本
    const thirdPartyScripts = document.querySelectorAll('script[src*="google"], script[src*="facebook"], script[src*="shopifycdn"]');
    
    thirdPartyScripts.forEach(script => {
      if (!script.hasAttribute('async') && !script.hasAttribute('defer')) {
        script.defer = true;
      }
    });

    // 移动端延迟加载社交媒体脚本
    if (window.innerWidth <= 768) {
      setTimeout(() => {
        const socialScripts = document.querySelectorAll('script[data-social]');
        socialScripts.forEach(script => {
          const newScript = document.createElement('script');
          newScript.src = script.src;
          newScript.async = true;
          document.body.appendChild(newScript);
        });
      }, 3000); // 3秒后再加载
    }
  }

  // 初始化优化
  function init() {
    // 立即执行关键优化（改善LCP和FCP）
    inlineCriticalCSS();
    preconnectDomains();
    preloadCriticalResources();
    optimizeFontLoading();
    optimizeLayout();
    deferNonCriticalScripts();
    optimizeImageLoading();
    optimizeTouchInteractions();
    optimizeViewport();
    optimizeThirdPartyScripts();

    // 延迟执行非关键优化
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initLazyLoading();
        preloadNextPage();
      });
    } else {
      initLazyLoading();
      preloadNextPage();
    }
  }

  // 启动优化
  init();
})();
